import { render, staticRenderFns } from "./JumbotronComponent.vue?vue&type=template&id=1c4d465e&scoped=true&"
import script from "./JumbotronComponent.vue?vue&type=script&lang=js&"
export * from "./JumbotronComponent.vue?vue&type=script&lang=js&"
import style0 from "./JumbotronComponent.vue?vue&type=style&index=0&id=1c4d465e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d465e",
  null
  
)

export default component.exports